import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const fileTypeValidator = (acceptedFormats: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const file: File = control.value;
    const fileType = file.name.match(/\.[0-9a-z]+$/i)?.[0];
    const isTypeValid = acceptedFormats.split(',').find((el) => el === fileType);

    if (!isTypeValid) {
      return { fileType: true };
    }

    return null;
  };
};
